import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const importerWalletContract = c.router({
  receiveTrustedImporter: {
    method: 'POST',
    path: '/TrustedImporter/:declarantId/:sellerWallet',
    pathParams: z.object({
      declarantId: z.string(),
      sellerWallet: z.string(),
    }),
    body: z.object({
      format: z.string(),
      credential: z.string(),
      c_nonce: z.string(),
      c_nonce_expires_in: z.number(),
    }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  recievePowerOfAttorney: {
    method: 'POST',
    path: '/PowerOfAttorney/:declarantId/:importerId?',
    pathParams: z.object({
      declarantId: z.string(),
      importerId: z.string().optional(),
    }),
    body: z.object({ credential: z.string() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  recieveVATRepresentation: {
    method: 'POST',
    path: '/VATRepresentation/:declarantId/:importerId?',
    pathParams: z.object({
      declarantId: z.string(),
      importerId: z.string().optional(),
    }),
    body: z.object({ credential: z.string() }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
});
